import type { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { classificationCell } from "./scope-list-cells";

export type ScopeListPrintRow = {
  id: string;
  title: string;
  uniformat: string;
  uniformatCode: string;
  uniformatTitle: string;
  uniformatCustom: boolean;
  masterformat: string;
  masterformatCode: string;
  masterformatTitle: string;
  masterformatCustom: boolean;
  loc: string;
  note: string;
  bidPackage: string;
};

export function buildScopeListPrintColumnDefs(options: {
  includeLodAndNote: boolean;
  groupByBid: boolean;
}): ColDef<ScopeListPrintRow>[] {
  const columns: ColDef<ScopeListPrintRow>[] = [];

  if (options.groupByBid) {
    columns.push({
      colId: "bidPackage",
      field: "bidPackage",
      headerName: "Bid Package",
      minWidth: 160,
      flex: 1
    });
  }

  columns.push(
    {
      colId: "title",
      field: "title",
      headerName: "Title",
      minWidth: 180,
      flex: 1.1
    },
    {
      colId: "uniformat",
      field: "uniformat",
      headerName: "UniFormat",
      minWidth: 200,
      flex: 1.4,
      cellRenderer: (p: ICellRendererParams<ScopeListPrintRow>) =>
        classificationCell(
          "UF",
          p.data?.uniformatCode ?? "",
          p.data?.uniformatTitle ?? "",
          p.data?.uniformatCustom
        )
    },
    {
      colId: "masterformat",
      field: "masterformat",
      headerName: "MasterFormat",
      minWidth: 200,
      flex: 1.4,
      cellRenderer: (p: ICellRendererParams<ScopeListPrintRow>) =>
        classificationCell(
          "MF",
          p.data?.masterformatCode ?? "",
          p.data?.masterformatTitle ?? "",
          p.data?.masterformatCustom
        )
    }
  );

  if (options.includeLodAndNote) {
    columns.push(
      {
        colId: "loc",
        field: "loc",
        headerName: "LOD",
        minWidth: 180,
        flex: 1.2,
        valueFormatter: (p) => p.value || "—"
      },
      {
        colId: "note",
        field: "note",
        headerName: "Note",
        minWidth: 180,
        flex: 1.3,
        valueFormatter: (p) => p.value || "—"
      }
    );
  }

  return columns;
}
